import React from 'react';
import { BoxProps, Box } from './Box';

function Flex(props: BoxProps) {
  return <Box {...props}>{props.children}</Box>;
}

export { Flex };
